// components/ScreenshotsGallery.jsx
import React, { useState } from "react";
import "./ScreenshotsGallery.css";

const ScreenshotsGallery = ({ screenshots, teamMembers }) => {
  const [selectedScreenshot, setSelectedScreenshot] = useState(null);
  const [filter, setFilter] = useState('today');
  const [selectedMember, setSelectedMember] = useState('all');

  // Filter screenshots based on selection
  const filteredScreenshots = screenshots?.filter(shot => {
    if (selectedMember !== 'all' && shot.memberId !== selectedMember) return false;
    // Add time filtering logic here
    return true;
  }) || [];

  const ScreenshotThumbnail = ({ screenshot }) => (
    <div className="screenshot-thumbnail" onClick={() => setSelectedScreenshot(screenshot)}>
      <div className="thumbnail-image-container">
        <img src={screenshot.thumbnailUrl} alt={`Screenshot by ${screenshot.memberName}`} />
        <div className="thumbnail-overlay">
          <span className="timestamp">{screenshot.time}</span>
          <span className="app-badge">
            <i className={`bx ${screenshot.appIcon}`}></i>
          </span>
        </div>
      </div>
      <div className="thumbnail-footer">
        <div className="member-info">
          <div className="member-avatar">
            {screenshot.memberAvatar ? (
              <img src={screenshot.memberAvatar} alt={screenshot.memberName} />
            ) : (
              <div className="avatar-placeholder">{screenshot.memberName.charAt(0)}</div>
            )}
          </div>
          <span className="member-name">{screenshot.memberName}</span>
        </div>
        <div className={`productivity-badge ${screenshot.productivityScore > 70 ? 'high' : screenshot.productivityScore > 40 ? 'medium' : 'low'}`}>
          {screenshot.productivityScore}%
        </div>
      </div>
    </div>
  );

  const ScreenshotModal = () => {
    if (!selectedScreenshot) return null;

    return (
      <div className="screenshot-modal-overlay" onClick={() => setSelectedScreenshot(null)}>
        <div className="screenshot-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <div className="modal-member-info">
              <div className="modal-avatar">
                {selectedScreenshot.memberAvatar ? (
                  <img src={selectedScreenshot.memberAvatar} alt={selectedScreenshot.memberName} />
                ) : (
                  <div className="avatar-placeholder-large">{selectedScreenshot.memberName.charAt(0)}</div>
                )}
              </div>
              <div>
                <h4>{selectedScreenshot.memberName}</h4>
                <p className="modal-role">{selectedScreenshot.memberRole}</p>
              </div>
            </div>
            <button className="modal-close" onClick={() => setSelectedScreenshot(null)}>
              <i className="bx bx-x"></i>
            </button>
          </div>

          <div className="modal-content">
            <div className="screenshot-display">
              <img src={selectedScreenshot.fullSizeUrl} alt="Full screenshot" />
            </div>
            <div className="screenshot-metadata">
              <div className="metadata-section">
                <h5>Activity Details</h5>
                <div className="metadata-grid">
                  <div className="metadata-item">
                    <i className="bx bx-time"></i>
                    <div>
                      <label>Time</label>
                      <p>{selectedScreenshot.timestamp}</p>
                    </div>
                  </div>
                  <div className="metadata-item">
                    <i className="bx bx-desktop"></i>
                    <div>
                      <label>Application</label>
                      <p>{selectedScreenshot.application}</p>
                    </div>
                  </div>
                  <div className="metadata-item">
                    <i className="bx bx-timer"></i>
                    <div>
                      <label>Duration</label>
                      <p>{selectedScreenshot.duration}</p>
                    </div>
                  </div>
                  <div className="metadata-item">
                    <i className="bx bx-trending-up"></i>
                    <div>
                      <label>Productivity</label>
                      <p className={`productivity-text ${selectedScreenshot.productivityScore > 70 ? 'high' : selectedScreenshot.productivityScore > 40 ? 'medium' : 'low'}`}>
                        {selectedScreenshot.productivityScore}%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="screenshots-gallery">
      <div className="gallery-header">
        <div className="gallery-controls">
          <select className="filter-select" value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="week">This Week</option>
          </select>
          <select className="filter-select" value={selectedMember} onChange={(e) => setSelectedMember(e.target.value)}>
            <option value="all">All Members</option>
            {teamMembers?.map(member => (
              <option key={member.id} value={member.id}>{member.name}</option>
            ))}
          </select>
          <button className="refresh-btn">
            <i className="bx bx-refresh"></i>
          </button>
        </div>
        <div className="gallery-stats">
          <span className="stat-item">
            <i className="bx bx-camera"></i>
            {filteredScreenshots.length} screenshots
          </span>
        </div>
      </div>

      <div className="screenshots-grid">
        {filteredScreenshots.length > 0 ? (
          filteredScreenshots.map((screenshot) => (
            <ScreenshotThumbnail key={screenshot.id} screenshot={screenshot} />
          ))
        ) : (
          <div className="empty-gallery">
            <i className="bx bx-camera-off"></i>
            <p>No screenshots available</p>
          </div>
        )}
      </div>

      <ScreenshotModal />
    </div>
  );
};

export default ScreenshotsGallery;